export enum FirebasePathEnum {
  Cus = "firebaseInfo.cus",
  TicketNumber = "firebaseInfo.ticketNumber",
  Status = "firebaseInfo.status",
  TransferStatus = "firebaseInfo.transfer_status",
}
